import React, { createContext, useContext, useState, useCallback } from 'react';

interface SecondaryNavContextType {
    hasSecondaryNav: boolean;
    setHasSecondaryNav: (value: boolean) => void;
}

const SecondaryNavContext = createContext<SecondaryNavContextType>({
    hasSecondaryNav: false,
    setHasSecondaryNav: () => {},
});

export function SecondaryNavProvider({ children }: { children: React.ReactNode }) {
    const [hasSecondaryNav, setHasSecondaryNav] = useState(false);

    const setValue = useCallback((value: boolean) => {
        setHasSecondaryNav(value);
    }, []);

    return (
        <SecondaryNavContext.Provider value={{ hasSecondaryNav, setHasSecondaryNav: setValue }}>
            {children}
        </SecondaryNavContext.Provider>
    );
}

export function useSecondaryNav() {
    return useContext(SecondaryNavContext);
}
